// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j5uC","buttons":"styles_buttons__3AWZS"};